import React, { useState } from "react";
import axios from "axios";
import { format } from "date-fns";
import moment from "moment";

const baseURL = import.meta.env.VITE_API_URL;

const ReportDaily = () => {
  const [reportDaily, setReportDaily] = useState([]);
  const [tranDate, setTranDate] = useState(moment().format("YYYY-MM-DD"));
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const businessCode = localStorage.getItem("businessCode");
  const businessName = localStorage.getItem("businessName");
  const branchCodes = localStorage.getItem("branchCodes");

  const clearData = () => {
    setReportDaily([]);
  };
  const formatDate = (dateString) => {
    return format(new Date(dateString), "MM/dd/yyyy");
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      await handleReportDaily();
    }
  };
  const validateForm = () => {
    const errors = {};
    if (!tranDate) errors.tranDate = "Transaction Date is required";
    return errors;
  };
  const handleReportDaily = async () => {
    setLoading(true);
    clearData();
    setCurrentPage(1);
    try {
      console.log(businessCode);
      const formattedDate = formatDate(tranDate);
      const response = await axios.get(
        `${baseURL}/get/dailysales?BusinessCode=${businessName}&BranchCode=${branchCodes}&TranDate=${formattedDate}&Page=${currentPage}&PageSize=${pageSize}`
      );
      if (response.status === 204) {
        setReportDaily([]);
      } else {
        setReportDaily(response.data);
      }
      setIsDataFetched(true);
      setCurrentPage(1);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handlePageSizeChange = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1);
  };
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, reportDaily.length);
  const currentData = reportDaily.slice(startIndex, endIndex);
  const headers = [
    "Branch Code",
    "Branch Name",
    "OS",
    "SPK",
    "TSPK",
    "TSPKmin1",
    "TDO",
    "WOUE",
    "TWOUE",
    "TPartAmount",
    "TWOBP",
    "Target ATPM",
  ];

  return (
    <div className="min-h-screen bg-gray-100 pt-20 px-5">
      <div className="max-w-7xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">
          Report Daily Sales
        </h2>
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 sm:grid-cols-4 gap-6 mb-6"
        >
          <div>
            <label
              htmlFor="tranDate"
              className="block mb-2 text-sm font-medium text-gray-700"
            >
              Transaction Date
            </label>
            <input
              type="date"
              placeholder="Transaction Date"
              value={tranDate}
              className={`p-3 border w-full rounded-lg focus:outline-none focus:ring-2 ${errors.tranDate
                  ? "border-red-500 focus:ring-red-500"
                  : "focus:ring-blue-500"
                }`}
              onChange={(e) => setTranDate(e.target.value)}
            />
            {errors.tranDate && (
              <p className="text-red-500 text-sm mt-1">{errors.tranDate}</p>
            )}
          </div>
          <button
            type="submit"
            className="col-span-1 sm:col-span-4 bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition duration-300"
          >
            Generate Report
          </button>
        </form>

        {loading && <p className="text-blue-600">Loading...</p>}
        {isDataFetched && (
          <div>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-md overflow-hidden">
                <thead className="bg-gray-50 border-b-2 border-gray-200">
                  <tr>
                    {headers.map((header) => (
                      <th
                        key={header}
                        className="px-4 py-2 text-left text-sm font-semibold text-gray-600"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {currentData.map((item, index) => (
                    <tr
                      key={index}
                      className="hover:bg-gray-100 transition-colors"
                    >
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.KodeCabang}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.NamaCabang}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.OS}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.SPK}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.TSPK}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.TSPKmin1}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.TDO}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.WOUE}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.TWOUE}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.TPartAmount}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.TWOBP}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {item.TargetATPM}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-6 flex justify-between items-center">
              <div className="flex items-center space-x-4">
                <label htmlFor="pageSize" className="text-gray-700">
                  Show:
                </label>
                <select
                  id="pageSize"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 p-2.5"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300"
                >
                  Previous
                </button>
                <span>
                  Page {currentPage} of{" "}
                  {Math.ceil(reportDaily.length / pageSize)}
                </span>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage * pageSize >= reportDaily.length}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportDaily;
